import type { RequestParameters } from '@/types';
import { decodeBase64Url, encodeBase64Url } from '@/utils/base64url';

export class RequestParsingService {
  public static parseUrlEncodedJson(queryParameter: unknown): RequestParameters | null {
    if (typeof queryParameter === 'string') {
      return JSON.parse(decodeBase64Url(queryParameter)) as RequestParameters;
    }
    return null;
  }

  public static toUrlEncodedJson(data: object): string {
    return encodeBase64Url(JSON.stringify(data));
  }
}
